module.exports = __webpack_public_path__ + "media/images/top/img_interview_toyoshi-d5c4b9890db3fe70a36ddfc943f96d41.jpg";